export function textComparator(valueA: string, valueB: string) {

    if (typeof valueA !== "string" || typeof valueB !== "string") {
        return 0;
    }
    return valueA?.localeCompare(valueB, undefined, { sensitivity: "base" });
}
